export enum Companies {
  PLACEHUB = 'placehub',
  DEZKER = 'dezker',
  INVENZI = 'invenzi',
}
